<template>
    <section class="contract-online-sign-flow-select-signers">
        <div class="select-signers">
            <span class="title-select-signers">2 - Selecionar Assinantes</span>
            <span class="subtitle-select-signers">Selecione os usuários que devem assinar o contrato, ordem e os tipos de assinatura:</span>
        </div>

        <div class="envelope-status scroll-color">
            <div class="marker-paper-signers">
                <section class="content-marker-paper-signers">
                    <div class="signers">
                        <span>Assinantes</span>
                    </div>

                    <div class="subscription">
                        <span class="subscription-type">Tipo de Assinatura</span>
                    </div>
                </section>

                <section
                    class="draggable"
                >
                    <draggable
                        :list="signers"
                        class="list-group"
                        ghost-class="ghost"
                        :animation="200"
                        @start="dragging = true"
                        @end="dragging = false"
                        @change="setSigners(signers)"
                    >
                        <div v-for="(signer, index) in signers" :key="index" class="list-group-item">
                            <div class="items">
                                <div class="draggables">
                                    <div class="drag-image">
                                        <img :src="require('@/assets/imgs/drag-and-drop.svg')" />
                                    </div>

                                    <div class="checkbox">
                                        <ui-checkbox
                                            v-model="signer.selected"
                                            :checked="signer.selected"
                                            :disabled="signer.type === 'customer'"
                                            design="mgb-0"
                                        />
                                    </div>

                                    <div class="infos-user">
                                        <div class="name">{{ signer.name }}</div>
                                    </div>
                                </div>

                                <div class="options">
                                    <div class="select">
                                        <ui-select-v2
                                            v-model="signer.signature_type"
                                            :data="typeOptions"
                                            :error="!!formValidation.errors[signer.group]?.signature_type"
                                            :observation="formValidation.errors[signer.group]?.signature_type"
                                            return-value="value"
                                            background-color="#FFF"
                                            placeholder="Selecione o tipo de assinatura"
                                            design="mgb-0"
                                        />
                                    </div>

                                    <div v-if="signer.type == 'nonuser'" class="menu-card">
                                        <ui-menu-card>
                                            <button @click="editSigner(signer)">
                                                Configurações
                                            </button>
                                        </ui-menu-card>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasErrors(signer)" class="errors-list">
                                <ul>
                                    <li
                                        v-for="(error, index) in formValidation.errors[signer.group]"
                                        :key="index"
                                    >
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </draggable>
                </section>

                <span class="add-new-signers" @click="addSigner">
                    + Adicionar novo assinante
                </span>
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!formValidation.valid"
                    design="mw-200 primary lg"
                    @click="send"
                >
                    Solicitar Assinaturas
                </ui-button>
            </div>
        </div>

        <ui-add-signers-modal mode="assine_online" />
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiCheckbox } from '@/components/ui/form'
    import { uiMenuCard } from '@/components/ui'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'
    import draggable from 'vuedraggable'

    import { types } from '@/assets/js/data'

    import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-online-sign-contract-sign-flow-select-signers',

		components: {
			uiButton,
            uiSelectV2,
            uiCheckbox,
            uiMenuCard,
            uiAddSignersModal,
            draggable
		},

        data() {
            return {
                typeOptions: [...types]
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                signers: 'getSigners',
                formValidation: 'getFormValidation'
            })
        },

        mounted() {
            this.loadDealSigners()
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
				'loadDealSigners',
				'saveEnvelope',
				'setSigners'
			]),
            /**
             * Abre o modal para o cadastro de assinantes externos
             */
			addSigner() {
				this.$root.$emit('modal-open-assine_online-add-signers')
			},
            /**
             * Abre o modal para a edição de assinantes externos
             */
			editSigner(event) {
				this.$root.$emit('modal-open-assine_online-add-signers', event)
			},
            /**
             * Solicita o envio dos dados do envelope e caso esteja tudo correto, solicita
             * o fechamento do modal
             */
            send() {
                this.saveEnvelope().then(() => {
                    // Emite o evento para recarregar o component de Documentos e Contratos
                    let event = new CustomEvent('iframe--contracts-reload-page')
				    window.parent.document.dispatchEvent(event)
                    this.$emit('close')
                })
            },
            /**
             * Verifica se existem erros de formulário referentes a determinado assinante
             */
            hasErrors(signer) {
                return Object.keys(this.formValidation.errors[signer.group] || {}).length
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>